import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Persons = styled.div`
    padding: ${rem(40)} 0 ${rem(20)} 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${rem(40)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        justify-content: center;
    }
`;

export const Description = styled.p`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};
    color: ${({ theme }) => theme.colors.grey};
    margin: ${rem(20)} auto ${rem(10)} auto;
    max-width: ${rem(550)};

    @media (min-width: ${breakpoints.sm}px) {
        text-align: center;
        margin: -${rem(20)} auto ${rem(10)} auto;
    }
`;
